import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children, adminOnly }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isAdmin = useSelector((state) => state.auth.isAdmin);

  if (!isAuthenticated) {
    // Redirect to the login page if the user is not authenticated
    return <Navigate to="/login" />;
  }

  if (adminOnly && !isAdmin) {
    // Redirect to the user dashboard if the user is not an admin
    return <Navigate to="/mdt_dashboard/overview" />;
  }

  return children;
};

export default PrivateRoute;
